import { render, staticRenderFns } from "./card-coupon-item.vue?vue&type=template&id=0298e3ae&scoped=true&lang=pug&"
import script from "./card-coupon-item.vue?vue&type=script&lang=js&"
export * from "./card-coupon-item.vue?vue&type=script&lang=js&"
import style0 from "./card-coupon-item.vue?vue&type=style&index=0&id=0298e3ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298e3ae",
  null
  
)

export default component.exports